// import { Modal, Checkbox, Row, Col, Spin, Radio } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import {
 TAutomationTypes,
 useAssignBulkNewsLetterMutation,
 useAssignToActionPlanBulkMutation,
} from 'features/automation'
import { useAssignAlertBulkMutation } from 'features/alert'
import {
 TLeadCustomSelectAll,
 TSelectAllB,
 TSelectAllP,
 useAssignGroupToLeadBulkMutation,
} from 'features/leads'
import {
 TListTagStageSource,
 // useGetGroupsQuery
} from 'features/settings'
import TSSFormModal from 'features/settings/components/TSSFormModal'
import {
 FC,
 //  useMemo,
 useState,
} from 'react'
import { capitalizeFirstLetter } from 'utils/functions'
// import InfiniteScroll from 'react-infinite-scroller'
import useFetchPage2 from 'hooks/useFetchPage2'
// import useAuth from 'hooks/useAuth'
import { useAddRealtorSourceMutation } from 'features/realtors'
import BaseSelectorModal from 'components/elements/BaseSelector/BaseSelectorModal'
import { BaseSelectorOption } from 'components/elements/BaseSelector'

type AddTagsProp = TSelectAllP & {
 type?: 'lead' | 'actionPlan' | 'alert' | 'realtors' | TAutomationTypes
 selectedKeys?: any[]
 visible: boolean
 onCancel: () => void
 refetch?: () => void
 assignType: 'tag' | 'stage' | 'source'
 extraBody?: any
 customtSelectAll?: TLeadCustomSelectAll
 mode?: 'single' | 'multiple'
 onSuccess?: () => void
}

const AssignTagsStagesModal: FC<AddTagsProp> = ({
 type = 'lead',
 visible,
 onCancel,
 selectedKeys,
 refetch: refresh,
 filterInfo,
 selectAll,
 unSelected,
 assignType,
 extraBody,
 customtSelectAll,
 mode = 'multiple',
 onSuccess,
}) => {
 //  const { data, refetch, isLoading } = useGetGroupsQuery({ type: [assignType] })
 // const {} = useAuth()
 const [searchKey, setSearchKey] = useState('')
 const { isLoading, hasMore, fetchMore, refetch, flatData } =
  useFetchPage2<TListTagStageSource>('get-groups-name', {
   method: 'get',
   params: `type=${assignType}&search=${searchKey}`,
  })
 const [selected, setSelected] = useState<BaseSelectorOption<any>[]>()
 //  const [ids, setIds] = useState<string[]>([])
 const [showAdd, setAddModal] = useState(false)

 const [assignToActionPlanBulk, { isLoading: actionLoading }] =
  useAssignToActionPlanBulkMutation()
 const [assignAlertBulk, { isLoading: tagLoading }] =
  useAssignAlertBulkMutation()
 const [assignToLead, { isLoading: leadLoading }] =
  useAssignGroupToLeadBulkMutation()
 const [assingnNewsLetterBulk, { isLoading: newsLetterLoading }] =
  useAssignBulkNewsLetterMutation()
 const [addRealtorSource, { isLoading: realtorSourceLoading }] =
  useAddRealtorSourceMutation()

 const handleClose = (): void => {
  onCancel?.()
  setSelected([])
  // setIds([])
 }

 const handleSubmit = async (grpIds: any[]): Promise<void> => {
  const body: TSelectAllB & {
   customtSelectAll?: TLeadCustomSelectAll
   type?: 'tag' | 'stage' | 'source'
   selectall_type?: 'tag' | 'stage' | 'source'
  } = {
   ...(type === 'Real-Estate-News-Letter' || type === 'market-update'
    ? { selectall_type: assignType }
    : { type: assignType }),
  }
  if (selectAll || customtSelectAll) {
   if (selectAll) {
    body.select_all = selectAll
   } else if (customtSelectAll) {
    body.customtSelectAll = customtSelectAll
   }
   body.unselected = unSelected
   body.filter_info = filterInfo
  }

  if (type === 'Real-Estate-News-Letter' || type === 'market-update') {
   await assingnNewsLetterBulk({
    ...body,
    type_id: grpIds?.map((i) => i?.id),
    newsletter_type: type,
    ...extraBody,
   })
  } else if (type === 'actionPlan') {
   await assignToActionPlanBulk({
    ...body,
    type_id: grpIds?.map((i) => i?.id),
    actionplan_id: selectAll || customtSelectAll ? [] : selectedKeys,
    ...extraBody,
   }).unwrap()
  } else if (type === 'alert') {
   await assignAlertBulk({
    ...body,
    type_id: grpIds?.map((i) => i?.id),
    alert_id: selectAll || customtSelectAll ? [] : selectedKeys,
    ...extraBody,
   }).unwrap()
  } else if (type === 'realtors') {
   await addRealtorSource({
    ...body,
    realtor_id: selectAll || customtSelectAll ? [] : selectedKeys,
    source_id: grpIds?.map((i) => i?.id),
    ...extraBody,
   }).unwrap()
  } else {
   await assignToLead({
    ...body,
    group_id: grpIds?.map((i) => i?.id),
    lead_id: selectAll || customtSelectAll ? [] : selectedKeys,
    ...extraBody,
   }).unwrap()
  }
  handleClose?.()
  refresh?.()
  onSuccess?.()
 }

 //  const options = assignType === 'stage' ? data?.stage : data?.tag
 //  const Component = assignType === 'tag' ? Checkbox.Group : Radio.Group

 //  if (
 //   ['Real-Estate-News-Letter', 'market-update', 'actionPlan']?.includes(type)
 //  ) {
 return (
  <>
   <BaseSelectorModal
    //  defaultIds={defaultTagIds}
    onChange={(v) => setSelected(v)}
    value={selected}
    DataIsLoading={isLoading}
    searchPlaceholder={`Search ${capitalizeFirstLetter(assignType)}s`}
    confirmLoading={
     newsLetterLoading ||
     actionLoading ||
     tagLoading ||
     realtorSourceLoading ||
     leadLoading
    }
    handleSubmit={handleSubmit}
    open={visible}
    okText="Submit"
    onCancel={handleClose}
    title={
     <>
      Assign {capitalizeFirstLetter(assignType)}{' '}
      <BaseButton
       onClick={() => setAddModal(true)}
       className="ms-2"
       icon={<i className="fas fa-plus me-2" />}
      >
       Add New {capitalizeFirstLetter(assignType)}{' '}
      </BaseButton>
     </>
    }
    // type={assignType === 'tag' ? 'multiple' : 'single'}
    type={mode}
    onSearch={(v) => setSearchKey(v)}
    data={flatData?.map((v) => ({ extra: v, id: v.id, title: v.name }))}
    fetchMore={fetchMore}
    hasMore={hasMore}
   />
   {showAdd && (
    <TSSFormModal
     onSuccess={(val) => {
      if (mode === 'multiple') {
       setSelected((prv) => [
        ...(prv ?? []),
        { id: val?.id, title: val?.name, extra: val },
       ])
      } else {
       setSelected([{ id: val?.id, title: val?.name, extra: val }])
      }
      // setDefaultSelected([{ id: val?.id, title: val?.name, extra: val }])
      refetch?.()
     }}
     type={assignType}
     onCancel={() => setAddModal(false)}
     visible={showAdd}
    />
   )}
  </>
 )
 //  }

 //  return (
 //   <Modal
 //    forceRender
 //    confirmLoading={
 //     type === 'Real-Estate-News-Letter' || type === 'market-update'
 //      ? newsLetterLoading
 //      : type === 'actionPlan'
 //      ? actionLoading
 //      : type === 'alert'
 //      ? tagLoading
 //      : type === 'realtors'
 //      ? realtorSourceLoading
 //      : leadLoading
 //    }
 //    okButtonProps={{ disabled: ids?.length === 0 }}
 //    onOk={handleSubmit}
 //    okText="Submit"
 //    onCancel={handleClose}
 //    visible={visible}
 //    title={`Assign ${capitalizeFirstLetter(assignType)}`}
 //   >
 //    <Spin className="w-100 text-center" spinning={isLoading}>
 //     {flatData && flatData?.length > 0 && (
 //      <>
 //       {/* <Col span={24}> */}
 //       <BaseButton
 //        onClick={() => setAddModal(true)}
 //        block
 //        buttonType="primary"
 //        customClass="mb-3"
 //       >
 //        <i className="fas fa-plus me-2" /> Add{' '}
 //        {capitalizeFirstLetter(assignType)}
 //       </BaseButton>
 //       {/* </Col> */}

 //       <div style={{ maxHeight: '400px', padding: '10px', overflow: 'auto' }}>
 //        <InfiniteScroll
 //         pageStart={0}
 //         loadMore={fetchMore}
 //         hasMore={hasMore}
 //         loader={
 //          <div className="text-center py-2">
 //           <Spin />
 //          </div>
 //         }
 //         useWindow={false}
 //        >
 //         <Component
 //          value={assignType === 'tag' ? ids : (ids?.[0] as any)}
 //          style={{ width: '100%' }}
 //          onChange={(e: any) => {
 //           setIds(assignType === 'tag' ? e : [e?.target?.value])
 //          }}
 //         >
 //          <Row gutter={[10, 10]}>
 //           {flatData?.map((v) => (
 //            <Col flex={1} key={v.id}>
 //             {assignType === 'tag' ? (
 //              <Checkbox className="btn-checkbox" value={v.id}>
 //               <span style={{ whiteSpace: 'normal' }}>{v.name}</span>
 //              </Checkbox>
 //             ) : (
 //              <Radio className="btn-checkbox" value={v.id}>
 //               <span style={{ whiteSpace: 'normal' }}>{v.name}</span>
 //              </Radio>
 //             )}
 //            </Col>
 //           ))}
 //          </Row>
 //         </Component>
 //        </InfiniteScroll>
 //       </div>
 //      </>
 //     )}
 //    </Spin>

 //    {showAdd && (
 //     <TSSFormModal
 //      onSuccess={refetch}
 //      type={assignType}
 //      onCancel={() => setAddModal(false)}
 //      visible={showAdd}
 //     />
 //    )}
 //   </Modal>
 //  )
}

export default AssignTagsStagesModal
